import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppInformationService } from '../app-information.service';
import { environment } from '../../../environments/environment';
import { Confirmation, StateTaxExemption } from '../model/entity-model';
import { Guid } from './entities';
import { DealerEntryModel } from '../model/dealer-entry-model';
import { DealerEntryAttachmentModel } from '../model/dealer-entry-attachment-model';
import { AchEmailModel } from 'app/portal/ach-email-dialog/ach-email-dialog.component';

@Injectable()
export class PortalService {
    // static clientName: string = 'http://localhost:44381';
    static clientName: string = 'https://genesistrailers.azurewebsites.net';
    static serviceName: string;
    static functionName: any;

    constructor(private http: HttpClient, private appInfo: AppInformationService) {
        PortalService.serviceName = environment.serviceName;
    }

    // leave this as async so it doesn't hang up anything
    async getConfirmation(confirmationCode: any) {
        const result = await this.http
            .post(`${environment.serviceName}/portal/getConfirmation`, {
                confirmationCode: confirmationCode,
            })
            .toPromise();
        return result;
    }

    async verifyConfirmationStillActive(confirmationCode: any) {
        const result = await this.http
            .post(`${environment.serviceName}/portal/confirmationStillActive`, {
                confirmationCode: confirmationCode,
            })
            .toPromise();
        return result;
    }

    async confirmationResponse(
        confirmationCode: any,
        mode: string,
        paymentMethodId: number,
        confirmedBy: string,
        cancelReason: string,
        cancelNotes: string,
        requestedSalesRepContact: boolean,
        achEmail: string,
        northpointOrRedOakNumber: string,
        deliveryOptionId: number,

    ) {
        const result = await this.http
            .post(`${environment.serviceName}/portal/confirmationResponse`, {
                confirmationCode: confirmationCode,
                mode: mode,
                paymentMethodId: paymentMethodId,
                confirmedBy: confirmedBy,
                cancelReason: cancelReason,
                cancelNotes: cancelNotes,
                requestedSalesRepContact: requestedSalesRepContact,
                achEmail: achEmail,
                northpointOrRedOakNumber: northpointOrRedOakNumber,
                deliveryOptionId: deliveryOptionId,
            })
            .toPromise();
        return result;
    }

    async emailConfirmations(typeId: number, messageId: number, dealerIds: number[], createdBy: string, orderId?: number) {
        const result = await this.http
            .post(`${environment.serviceName}/portal/emailConfirmations`, {
                typeId: typeId,
                messageId: messageId,
                dealerIds: dealerIds,
                createdBy: createdBy,
                orderId: orderId,
            })
            .toPromise();
        return result;
    }

    getConfirmationUrl(confirmation: Confirmation) {
        return `${PortalService.clientName}/portal/dealer-confirmation/${confirmation.code}`;
    }

    async getStateTaxExemptions() {
        return await this.http.get<StateTaxExemption[]>(`${environment.serviceName}/portal/getStateTaxExemptions`).toPromise();
    }

    async getDealerEntry(code: Guid) {
        return await this.http.get<DealerEntryModel>(`${environment.serviceName}/portal/getDealerEntry?code=${code}`).toPromise();
    }

    async setDealerEntryViewed(code: Guid) {
        return await this.http.post<boolean>(`${environment.serviceName}/portal/dealerEntryViewed`, { code }).toPromise();
    }

    async submitDealerEntry(dealerEntry: DealerEntryModel) {
        return await this.http.post<boolean>(`${environment.serviceName}/portal/submitDealerEntry`, dealerEntry).toPromise();
    }

    async sendNewDealerAlert(code: Guid) {
        try {
            return await this.http.post<boolean>(`${environment.serviceName}/portal/sendNewDealerAlert`, { code }).toPromise();
        } catch (ex) {
            return null;
        }
    }

    async getDealerEntryAttachments(code: Guid) {
        return await this.http.post<DealerEntryAttachmentModel[]>(`${environment.serviceName}/file/getDealerEntryAttachments`, { code }).toPromise();
    }

    async deleteDealerEntryAttachment(attachmentId: number, code: Guid) {
        return await this.http.post<boolean>(`${environment.serviceName}/file/deleteDealerEntryAttachment`, { attachmentId, code }).toPromise();
    }

    async getNewDealerPdf() {
        return await this.http.get<string>(`${environment.serviceName}/portal/getNewDealerPdf`).toPromise();
    }

    async getAchInfo(achCode: Guid) {
        return await this.http.post<{ success: boolean; message?: string; value: any }>(`${environment.serviceName}/portal/getAchInfo`, { achCode }).toPromise();
    }

    async isAchValid(achCode: Guid) {
        return await this.http.post<{ success: boolean; message?: string }>(`${environment.serviceName}/portal/isAchValid`, { achCode }).toPromise();
    }

    async printAchForm(achCode: Guid) {
        window.open(`${environment.serviceName}/portal/achForm?achCode=${achCode}`, '_blank');
    }

    async getAchEmail(dealerId: number) {
        return await this.http.post<AchEmailModel>(`${environment.serviceName}/portal/getAchEmail`, { dealerId }).toPromise();
    }

    async sendAchEmail(model: any) {
        console.log(model)
        return await this.http.post<boolean>(`${environment.serviceName}/portal/sendAchEmail`, model).toPromise();
    }

    async verifyAchEmailSent(confirmationCode: Guid) {
        return await this.http.post<{ Emailed: string; EmailTo: string } | null>(`${environment.serviceName}/portal/verifyAchEmailSent`, { confirmationCode }).toPromise();
    }

    async approveAch(ach: any) {
        return await this.http.post<{ success: boolean; message?: string }>(`${environment.serviceName}/portal/approveAch`, ach).toPromise();
    }

    async declineAch(achCode: Guid, declineReason: string) {
        return await this.http.post<{ success: boolean; message?: string }>(`${environment.serviceName}/portal/declineAch`, { achCode, declineReason }).toPromise();
    }

    async submittedManually(achCode: Guid) {
        return await this.http.post<{ success: boolean; message?: string }>(`${environment.serviceName}/portal/submittedManually`, { achCode }).toPromise();
    }

    async deleteAch(confirmationCode: Guid) {
        return await this.http.post<{ success: boolean; message?: string }>(`${environment.serviceName}/portal/deleteAch`, { confirmationCode }).toPromise();
    }
    async checkForAchesToDelete(confirmationCode: Guid) {
        return await this.http.post<{ success: boolean; message?: string }>(`${environment.serviceName}/portal/checkForAchesToDelete`, { confirmationCode }).toPromise();
    }
}
